import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import UserPage from 'flarum/forum/components/UserPage';
import CommentPost from 'flarum/forum/components/CommentPost';
import Post from 'flarum/common/models/Post';
import LogInModal from 'flarum/forum/components/LogInModal';
import ActivateCodeModal from './components/ActivateCodeModal';
import UserCoursesPage from './components/UserCoursesPage';
import Button from 'flarum/common/components/Button';

function consumeExchangeErrorFromUrl() {
  try {
    const params = new URLSearchParams(window.location.search || '');
    const error = params.get('exchange_error');
    if (!error) {
      return null;
    }
    params.delete('exchange_error');
    const query = params.toString();
    const next = window.location.pathname + (query ? '?' + query : '') + (window.location.hash || '');
    window.history.replaceState(null, '', next);
    return error;
  } catch (e) {
    return null;
  }
}

const pendingExchangeError = consumeExchangeErrorFromUrl();

app.initializers.add('tf-cns-courses-forum', () => {
  // 将 ActivateCodeModal 注册到 app 中，以便其他扩展可以访问
  app.activateCodeModal = ActivateCodeModal;

  if (pendingExchangeError) {
    const showExchangeError = () => {
      const key = 'tf-cns-courses.forum.exchange.errors.' + pendingExchangeError;
      const translated = app.translator.trans(key);
      const message = Array.isArray(translated) ? translated.join('') : String(translated || '');
      app.alerts.show(
        { type: 'error' },
        message && message !== key
          ? message
          : app.translator.trans('tf-cns-courses.forum.exchange.errors.exchange_failed')
      );
    };
    setTimeout(showExchangeError, 0);
  }

  // 注册用户课程页面路由
  app.routes['user.courses'] = {
    path: '/u/:username/courses',
    component: UserCoursesPage
  };

  // 付费课程首帖预览时：在内容后添加解锁按钮，点击弹出激活码弹窗（不自动弹窗）
  extend(CommentPost.prototype, 'bodyItems', function (items) {
    const post = this.attrs.post;
    if (!post || (post.number && post.number() !== 1)) return;
    const discussion = post.discussion ? post.discussion() : null;
    if (!discussion) return;
    const courseInfo = discussion.attribute ? discussion.attribute('groupCourse') : null;
    if (!courseInfo || ((courseInfo.price || 0) <= 0 && courseInfo.courseType !== 'paid')) return;
    const isPreview = post.attribute ? post.attribute('isPreview') : (post.data && post.data.attributes && post.data.attributes.isPreview);
    if (!isPreview) return;
    items.add(
      'courseUnlockButton',
      <div className="CoursePost-unlockWrapper">
        <Button
          className="Button Button--primary CoursePost-unlockButton"
          icon="fa-solid fa-lock-open"
          onclick={() => {
            if (!app.session.user) {
              app.modal.show(LogInModal);
              return;
            }
            const discussionId = discussion.id ? discussion.id() : discussion.id;
            if (app.activateCodeModal) {
              app.modal.show(app.activateCodeModal, { discussionId });
            }
          }}
        >
          {app.translator.trans('tf-cns-courses.forum.course.unlock_button')}
        </Button>
      </div>,
      5   // 高于 Post-stats(3)，显示在 Post-stats 上边
    );
  });
  
  // 在导航栏添加激活码按钮
  // extend(HeaderPrimary.prototype, 'items', function (items) {
  //   if (app.session.user) {
  //     items.add(
  //       'activate-code',
  //       <Button
  //         className="Button Button--link"
  //         onclick={() => app.modal.show(ActivateCodeModal)}
  //       >
  //         <i className="fa-light fa-key"></i> {app.translator.trans('tf-cns-courses.forum.activate_code.button')}
  //       </Button>,
  //       10
  //     );
  //   }
  // });

  // 在个人中心导航中添加课程导航项
  extend(UserPage.prototype, 'sidebarItems', function (items) {
    const user = this.user;
    if (!user) return items;

    // 获取当前路由信息
    const currentRoute = app.current.get('routeName');
    const username = user.slug();
    
    // Courses 导航项（我的课程）
    const isCoursesActive = currentRoute === 'user.courses';
    items.add(
      'courses',
      <a
        className={'UserPage-navItem' + (isCoursesActive ? ' active' : '')}
        href={app.route('user.courses', { username })}
        onclick={(e) => {
          e.preventDefault();
          m.route.set(app.route('user.courses', { username }));
        }}
      >
        <i className="icon fa-light fa-book" />
        <span className="label">{app.translator.trans('tf-custom-profile.forum.nav.courses')}</span>
      </a>,
      74
    );
  });
});

